import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useResolvedPath, Navigate } from "react-router-dom";
import { setNavi, setHideHeader } from "actions";

import { Helmet } from "react-helmet-async";
import ReactHtmlParser from "react-html-parser";
import Col3Container from "components/standart/col3Container";
import { scrollTop } from "components/standart";
import { frontendApi } from "reducers/api";
import Error404 from "./error404";

const { api } = frontendApi.actions;

const Content = (props) => {
  const url = useResolvedPath("").pathname;
  const { locales } = props;
  const [staticContent, setStaticContent] = useState(null);
  const [isLoaded, setLoaded] = useState(false);

  useEffect(() => {
    scrollTop();
    props.setHideHeader(false);
    const localeId = locales.data._id;
    localeId &&
      props.getContent(
        { query: { url, localeId } },
        //
        {
          onSuccess(body) {
            setStaticContent(body);
            setLoaded(true);
          },
          onFailure() {
            setLoaded(true);
          },
        }
      );
  }, [url, locales.data]);

  return isLoaded ? (
    staticContent ? (
      <>
        {/*SEO Support*/}
        <Helmet>
          <title>{staticContent.meta?.title}</title>
          <meta name="description" content={staticContent.meta?.description} />
          <meta property="og:title" content={staticContent.meta?.title} />
          <meta property="og:description" content={staticContent.meta?.description} />
        </Helmet>

        <section>
          <div className="container">
            <Col3Container>
              <div className="standart-header mb-2">
                <b>{staticContent.title}</b>
              </div>
              <div>{ReactHtmlParser(staticContent.data)}</div>
            </Col3Container>
          </div>
        </section>
      </>
    ) : (
      <Navigate to={"/"} replace />
      // <Error404 />
    )
  ) : null;
};

const mapStateToProps = (state) => ({
  locales: state.locales,
});
export default connect(mapStateToProps, {
  getContent: api.get("/content"),
  setNavi,
  setHideHeader,
})(Content);
